import React, { useEffect } from "react";
import DynamicSimpleTable from "../../../../../../../util/DynamicSimpleReactTable";
import {
    formatDate,
    formatStatus,
    truncateString,
    formatAmount,
    ucFirst,
    transactionCat,
    transactionType,
    errorMessage
} from "../../../../../../../util/Helpers";
import cogoToast from "cogo-toast";
import { CardHeader, CardHeaderToolbar } from "../../../../../../../../_metronic/_partials/controls";
import { Permissions, PermissionType } from "../../../../../../../util/Permissions";
import { useDownloadTransactionsReportMutation } from "../../../../../../../../redux/apiSlice";
import { Permission } from "../../../../../../Common/layout/Permission";

const Activities = ({
    match: {
        params: {
            userId
        }
    }
}) => {
    const [
        downloadTransactionsReport,
        {
            isLoading: isLoadingReport,
            isSuccess: isReportGenerating,
            error: errorReport,
        }
    ] = useDownloadTransactionsReportMutation()

    useEffect(() => {
        if (errorReport) {
            cogoToast.error(errorReport.data);
        }
    }, [errorReport])

    useEffect(() => {
        if (isReportGenerating) {
            cogoToast.success(`Transactions export in progress. The resulting file will be sent to your mail.`);
        }
    }, [isReportGenerating])

    const formatActivity = row => {
        return <div className="d-flex align-items-center">
            <div className="symbol symbol-50 flex-shrink-0 mr-4">
                <span className="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg">
                    {transactionType(row)}
                    <span className="text-muted pl-2">
                        {transactionCat(row)}
                    </span>
                </span>
            </div>
        </div>
    }

    return <div className="card card-custom gutter-b">
        <div className="row">
            <div className="col-12">
                {/* <!--begin::List Widget 14--> */}
                <div className="card card-custom gutter-b">
                    {/* <!--begin::Header--> */}
                    {/* <div className="card-header border-0"> */}
                    {/* <!--begin::Title--> */}
                    {/* <div className="card-title pt-5 w-100">
                            <h3 className="card-label">
                                <span className="d-block text-dark h3 font-weight-bolder">Activities</span>
                                <span className="d-block text-muted mt-2 font-size-sm">Consolidated User Activities</span>
                            </h3>
                        </div> */}
                    <CardHeader title={`Activities`}>
                        <Permission permission={Permissions.REPORTS} permissionType={PermissionType.CREATE}>
                            <CardHeaderToolbar>
                                <button
                                    type="button"
                                    className="btn btn-primary mr-4"
                                    disabled={isLoadingReport}
                                    onClick={() => downloadTransactionsReport({
                                        userId,
                                        liveData: true,
                                        format: "xlsx",
                                    })}
                                >
                                    Export XLSX
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    disabled={isLoadingReport}
                                    onClick={() => downloadTransactionsReport({
                                        userId,
                                        liveData: true,
                                        format: "csv",
                                    })}
                                >
                                    Export CSV
                                </button>
                            </CardHeaderToolbar>
                        </Permission>
                    </CardHeader>
                    {/* </div> */}
                    {/* <!--end::Header--> */}
                    {/* <!--begin::Body--> */}
                    <div className="card-body pt-0">
                        <DynamicSimpleTable
                            queryParams={
                                `userId=${userId}`
                            }
                            searchBox={true}
                            source={{ url: `/transactions` }}
                            columns={[
                                { title: "ACTIVITY", format: formatActivity },
                                { title: "DATE", format: row => formatDate(row.created) },
                                { title: "REFERENCE", format: row => truncateString(row.refId || row.autoId, 18) },
                                { title: "DESCRIPTION", key: "comment" },
                                { title: "AMOUNT", format: row => formatAmount(row.currency, row.tranAmount) },
                                { title: "STATUS", format: row => formatStatus(ucFirst(row.tranStatus)) },
                                { title: "SOURCE", key: "source" },
                                { title: "DESTINATION", key: "destination" },
                            ]}
                            onError={(err) =>
                                cogoToast.error(errorMessage(err))
                            }
                            refreshIcon={true}
                        />
                    </div>
                    {/* <!--end::Body--> */}
                </div>
                {/* <!--end::List Widget 14--> */}
            </div>
        </div>
    </div>

}

export default Activities;